import axios from "../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../utils/helpers";
import { IExportPdf, IProviderSessionFilters } from "../utils/types";

export async function fetchDiagnosisCodes(
    showDeprecatedCode?: boolean,
    code?: string,
    signal?: AbortSignal
) {
    const response = await axios.get(`/diagnosis/diagnosis_codes`, {
        signal,
        params: {
            show_deprecated_code: showDeprecatedCode,
            code,
        },
    });
    return response.data;
}

// Fetch all provider's sessions
export async function fetchProviderSessions(filters?: IProviderSessionFilters) {
    const response = await axios.get(`/clients/sessions`, {
        params: handleRemoveEmptyParamFromQueryParams({
            ...filters,
        }),
    });
    return response.data;
}

// Fetch single session details
export async function fetchSingleSessionDetails(sessionHistoryId: string) {
    const response = await axios.get(
        `/session_history?session_history_id=${sessionHistoryId}`
    );
    return response.data;
}

// Get uploaded document buffer
export async function fetchDocument(fileUrl: string) {
    const response = await axios.get(`/file?file_url=${fileUrl}`);
    return response.data;
}

// Export/download zipped file
export async function exportPdfs(params: IExportPdf) {
    const response = await axios.get("/pdf/export", {
        params: handleRemoveEmptyParamFromQueryParams(params),
        responseType: "blob",
    });
    return response.data;
}
